function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.44 10.06h-.73l-.25-.24a5.93 5.93 0 10-.64.64l.24.25v.73L14.64 16 16 14.64zm-5.44 0A4.12 4.12 0 1110.06 6 4.11 4.11 0 016 10.06z"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgSearch;